import React from "react";
import { Avatar, Typography } from "@material-ui/core";


const AppIcon = (props) => {
    const { targetUrl, title } = props;

    return (
        <a
            className="wfr-clickable"
            href={targetUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{
                width: "84px",
                height: "84px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textDecoration: 'none'
            }}
        >
            <Avatar />
            <Typography className="wfr-title" style={{ textAlign: "center" }}>{title}</Typography>
        </a>
    );
};

export default AppIcon;
